/**
 * Legacy preview route compatibility (removed step — redirects to Envelope Setup).
 * Redirects to Envelope Setup while preserving wizard navigation state.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const Step6FinalPreviewRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      to="/dispute-wizard/step7-envelope"
      replace
      state={location.state}
    />
  );
};

export default Step6FinalPreviewRedirect;
